/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Image from 'components/Image';
import Modal from 'components/Modal';
import ScrollDown from 'components/ScrollDown';
import SectionIndustries from 'components/SectionIndustries';
import SectionContact from 'components/SectionContact';

import SettingsIcon from 'images/icons/settings.svg';

import { SolutionsContainer } from 'styles/solutions';

import { indexSolutions } from 'utils/contentProvider';

const SolutionsPage = ({ path }) => {
  const [isVideoOpen, setVideoOpen] = useState(false);

  function toggleVideoOpen() {
    setVideoOpen(!isVideoOpen);
  }

  return (
    <>
      <Meta
        title="Modern Enterprise Solutions - Bring your ideas to life and scale your business."
        description="Maintain your competitive edge in an increasingly fast moving and difficult digital environment time by actively staying at the forefront of technology."
      />
      <Layout
        path={path}
        renderOutsideScrollContainer={
          <Modal isOpen={isVideoOpen} toggle={toggleVideoOpen}>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/ZdVfFV8sl10"
              frameBorder="0"
              title="About ATC"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Modal>
        }
      >
        <SolutionsContainer>
          <section>
            <div className="container">
              <div className="inner-hero-area" style={{ paddingBottom: 28 }}>
                <ScrollDown />
                <div className="row">
                  <div className="col-md-6">
                    <h1 className="white-txt">
                      Solutions to bring your ideas to life and
                      <span className="pink"> scale your business</span>
                      <span>.</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="offer-solution-main">
              <div className="container">
                <div className="row align-items-end">
                  <div className="col-md-5">
                    <div className="offer-txt-head">
                      <p>
                        Evolve your business with solutions for
                        <span />
                      </p>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="offer-txt-head">
                      <p>
                        Maintain your competitive edge in an increasingly fast
                        moving and difficult digital environment time by
                        actively staying at the forefront of technology. We help
                        you solve seemingly complex problems in surprisingly
                        simple ways.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="solution-offer-area">
                  <div className="row no-gutters">
                    <div className="col-md-4 no-gutters">
                      <Image
                        type="background"
                        tag="div"
                        className="solution-offser-single darken-image"
                        src="home/industry-1.jpg"
                      >
                        <p className="solution-rotate-txt">
                          LOGISTICS
                          <span />
                        </p>
                      </Image>
                    </div>
                    <div className="col-md-4 no-gutters">
                      <Image
                        type="background"
                        tag="div"
                        className="solution-offser-single darken-image"
                        src="home/industry-2.jpg"
                      >
                        <p className="solution-rotate-txt">
                          HEALTHCARE
                          <span />
                        </p>
                      </Image>
                    </div>
                    <div className="col-md-4 no-gutters">
                      <Image
                        type="background"
                        tag="div"
                        className="solution-offser-single darken-image"
                        src="home/industry-3.jpg"
                      >
                        <p className="solution-rotate-txt">
                          FINANCE
                          <span />
                        </p>
                      </Image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="white-bg-section pt-1">
            <div className="container">
              <div className="solution-video-area">
                <button
                  type="button"
                  className="button-unstyled"
                  onClick={toggleVideoOpen}
                >
                  <Image
                    src="solutions/solution-video-thumbnail.jpg"
                    alt="build project"
                    style={{
                      width: 1150,
                      height: 574,
                      objectPosition: '50% top',
                    }}
                  />
                  <span className="play-icon">
                    <span className="icon" />
                  </span>
                </button>
              </div>
            </div>
          </section>

          <section className="white-bg-section">
            <div className="container">
              <div className="build-project-main">
                <h2>
                  Begin your evolution
                  <span className="pink">.</span>
                </h2>
                <div className="row">
                  <div className="col-md-6 offset-md-3">
                    <p className="build-project-subhead">
                      Staying on the cutting edge never ends. Let’s get started
                      actively evolving your business!
                    </p>
                  </div>
                </div>

                <div className="build-project-block">
                  <div className="row">
                    {indexSolutions.map((i) => (
                      <div key={i.id} className="col-md-3">
                        <Link to={i.link} className="build-project-single">
                          <SettingsIcon style={{ width: 23 }} />
                          <h4>{i.title}</h4>
                          <p>{i.excerpt}</p>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <SectionIndustries hideLinks />
          <SectionContact />
        </SolutionsContainer>
      </Layout>
    </>
  );
};

SolutionsPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionsPage;
